import type { SVGProps } from "react";

export const SettingsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 26"
    className="fill-current"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M9.813 2.61a1.33 1.33 0 0 1 1.306-1.063h2.495c.634 0 1.181.446 1.306 1.064l.605 2.92c.588.25 1.14.572 1.64.952l2.829-.94c.6-.2 1.26.051 1.577.602l1.247 2.16c.317.552.205 1.244-.27 1.666l-2.225 1.977q.056.465.055.947c0 .322-.021.639-.055.948l2.228 1.981c.476.422.585 1.119.272 1.665l-1.248 2.161a1.34 1.34 0 0 1-1.577.601l-2.829-.939a8 8 0 0 1-1.64.952l-.6 2.916a1.334 1.334 0 0 1-1.306 1.064h-2.495c-.635 0-1.181-.446-1.306-1.064l-.601-2.916a7.8 7.8 0 0 1-1.64-.952l-2.841.94c-.6.2-1.26-.05-1.577-.602l-1.248-2.16a1.33 1.33 0 0 1 .272-1.666l2.228-1.981a8 8 0 0 1-.055-.947c0-.322.021-.639.054-.948L2.188 9.967a1.34 1.34 0 0 1-.272-1.665L3.163 6.14c.317-.551.976-.802 1.577-.601l2.829.939a8 8 0 0 1 1.64-.952zm2.554 13.623a3.337 3.337 0 1 0-.025-6.676 3.337 3.337 0 1 0 .025 6.676Z"
    />
  </svg>
);
